import { defineComponent as _defineComponent } from 'vue'
import router from "@/router";
  import { onMounted, ref } from "vue";
  import store from "@/store";
  import { normalizeWaitlistDetails } from "@/helpers/customer/normalizer";
  import { CustomerWaitlistDetails } from "@/types/CustomerWaitlistDetails";
  import ActionsComponent from "@/components/ui/ActionsComponent.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerWaitlistDetailsView',
  setup(__props, { expose: __expose }) {
  __expose();

  const subscriptionId = router.currentRoute.value.params.id;
  const isFetching = ref(false);
  const data = ref({} as CustomerWaitlistDetails);
  const showActions = ref(false);

  onMounted(() => {
    fetchDetails();
  });

  function onDots() {
    showActions.value = !showActions.value;
  }
  function clickOutside() {
    showActions.value = false;
  }
  function onEdit() {
    router.push({
      name: "CustomerWaitlistDetailsEditView",
      params: { id: subscriptionId },
    });
  }
  function onDelete() {
    isFetching.value = true;
    setTimeout(() => {
      store
        .dispatch("subscription/removeFromWaitlist", subscriptionId)
        .finally(() => {
          router.push({ name: "CustomerWaitlist" });
          isFetching.value = false;
        });
    }, 600);
  }
  function onBack() {
    router.go(-1);
  }
  function onEstateCard() {
    router.push({
      name: "EstateMap",
      params: { estateId: data.value.estate.id },
    });
  }
  function fetchDetails() {
    isFetching.value = true;
    setTimeout(() => {
      store
        .dispatch("subscription/getSubscriptionById", subscriptionId)
        .then((response) => {
          data.value = normalizeWaitlistDetails(response.data);
        })
        .finally(() => {
          isFetching.value = false;
        });
    }, 600);
  }

const __returned__ = { subscriptionId, isFetching, data, showActions, onDots, clickOutside, onEdit, onDelete, onBack, onEstateCard, fetchDetails, get router() { return router }, onMounted, ref, get store() { return store }, get normalizeWaitlistDetails() { return normalizeWaitlistDetails }, get CustomerWaitlistDetails() { return CustomerWaitlistDetails }, ActionsComponent }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})